module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/img_id01-9b4d2d2fffb6f0bd2fbf32555d4a7a1c.png";